import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { Box, Button, Divider, Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { PostBasicStyle } from '../../Board/View/style';
import ParticipationContentItemSciforumViewPoster from './ParticipationContentItemSciforumViewPoster';

type Props = {
  post: any;
  movePost: (value: number) => void;
};

const navList = [
  {label: '모집', value: 'recruit'},
  {label: '프로그램', value: 'program'},
  {label: '포스터', value: 'poster'},
  {label: '자료집', value: 'data'},
  {label: '사진', value: 'photo'},
]

function ParticipationContentItemSciforumView({ post, movePost }: Props) {
  const [currentTab, setCurrentTab] = useState(navList[0].value as string);

  const onTabClick = (value:string) => {		
    switch (value) {
      case 'data':
        window?.open(post.meta.sciforum_board, '_blank')?.focus();
        break;
      case 'photo':
        window?.open(post.meta.sciforum_photo, '_blank')?.focus();
        break;
      default:
        setCurrentTab(value);
        break;
    }
  }

  return (
    <>
      <Divider mb="6" color="b.lg" />
        <Flex justify="space-between">
          <button onClick={() => movePost(+1)}><ArrowBackIcon /> 이전</button>
          <Box>
            {
              navList.map((item:any, index:number) => (
                <Button size="md" colorScheme={currentTab === item.value ? 'dgr' : 'g'} variant={currentTab === item.value ? 'solid' : 'outline'} key={index} mr="2" ml="2" pl="5" pr="5" onClick={() => onTabClick(item.value)}>                  
                  {item.label}
                </Button>
              ))
            }
          </Box>
          <button onClick={() => movePost(-1)}>다음 <ArrowForwardIcon /></button>
        </Flex>
      <Divider mt="6" mb="6" color="b.g" />
      {
        currentTab === 'recruit' && (
          <PostBasicStyle
            dangerouslySetInnerHTML={ {__html: post.content} } 
          />
        )
      }

      {
        currentTab === 'poster' && (
          <ParticipationContentItemSciforumViewPoster term={post?.slug} />
        )
      }

      {
        currentTab === 'program' && (
          <PostBasicStyle
            dangerouslySetInnerHTML={ {__html: post.meta?.sciforum_program} } 
          />
        )
      }
      
    </>
  );
}

ParticipationContentItemSciforumView.defaultProps = {
};

export default ParticipationContentItemSciforumView;
